<span class="d-flex align-items-baseline form-text font-12 mt-1">
  <i class="fas fa-info-circle mr-1"></i>
  {{ helperText() | translate }}
</span>
